import { useEffect, useRef, useCallback } from "react";

// Lightweight cross-window sync for undocked panels. All windows for the same
// project share a BroadcastChannel; when one changes data it pings the others,
// which refetch. Each window ignores its own pings (via a random origin id).
export default function useProjectSync(projectId, onRemoteChange) {
  const chanRef = useRef(null);
  const idRef = useRef(Math.random().toString(36).slice(2));
  const cbRef = useRef(onRemoteChange);
  useEffect(() => { cbRef.current = onRemoteChange; }, [onRemoteChange]);

  useEffect(() => {
    if (!projectId || typeof BroadcastChannel === "undefined") return undefined;
    const ch = new BroadcastChannel(`cs-sync-${projectId}`);
    chanRef.current = ch;
    ch.onmessage = (e) => { if (e.data && e.data.from !== idRef.current) cbRef.current?.(); };
    return () => { ch.close(); chanRef.current = null; };
  }, [projectId]);

  return useCallback(() => {
    try { chanRef.current?.postMessage({ from: idRef.current, t: Date.now() }); } catch { /* ignore */ }
  }, []);
}
